import * as z from "zod/v4";

export const createPrintNodeAccount = {
  name: "createPrintNodeAccount" as const,
  input: z.object({ email: z.string().email(), password: z.string() }),
  output: z.object({ success: z.boolean(), message: z.string().nullish() }),
};
